import { ComponentProps, useRef, useState } from "react"

import { twMerge } from "tailwind-merge"

import { Pill } from "~/src/components/BeeKit/Pill"

export type InputWithCannedResponsesProps = {
  containerClassName?: string
  inputClassName?: string
  cannedResponses: Array<string>
  onResponseChange?: (response: string) => void
} & ComponentProps<"textarea">

export const InputWithCannedResponses = (props: InputWithCannedResponsesProps) => {
  const { cannedResponses, onResponseChange, onChange, containerClassName, inputClassName, ...rest } = props

  const messageRef = useRef<HTMLTextAreaElement | null>(null)
  const [messageTextExists, setMessageTextExists] = useState(false)

  const onPillClicked = (message: string) => {
    if (messageRef.current) {
      messageRef.current.value = message
      setMessageTextExists(true)
      onResponseChange?.(message)
    }
  }

  return (
    <div className={twMerge("flex flex-col rounded border border-gray-300", containerClassName)}>
      <textarea
        ref={messageRef}
        className={twMerge(
          "h-[92px] grow resize-none border-none border-transparent focus:border-transparent focus:ring-0",
          inputClassName
        )}
        onChange={(e) => {
          setMessageTextExists(e.target.value !== "")
          onResponseChange?.(e.target.value)
          onChange?.(e)
        }}
        {...rest}
      />
      <div className={`mb-3 ml-2 flex flex-col flex-wrap gap-3 sm:flex-row ${messageTextExists ? "hidden" : ""}`}>
        {cannedResponses.map((response) => (
          <Pill className="text-gray-500 hover:cursor-pointer" key={response} onClick={() => onPillClicked(response)}>
            <span>{response}</span>
          </Pill>
        ))}
      </div>
    </div>
  )
}
